const menuData = [
  {
    imageSrc: '/images/mansaf.jpg',
    name: 'Mansaf',
    price: '$9.99',
    description: 'Jordanian Mansaf.',
  },
  {
    imageSrc: '/images/kabseh.jpeg',
    name: 'Kabseh',
    price: '$16.99',
    description: 'Kabseh Chicken (Kabseh bi Djej)',
  },
  {
    imageSrc: '/images/magloobeh.jpeg',
    name: 'Magloobeh',
    price: '$8.50',
    description:
      'Magloobeh, is a delicious Jordanian dish typically made with rice, chicken or meat and fried eggplant!.',
  },
  {
    imageSrc: '/images/musakhan.jpeg',
    name: 'Musakhan (Sumac Roasted Chicken)',
    price: '$14.50',
    description:
      'the national dish of Palestine and a true comfort food dish. Juicy slow-cooked chicken is flavored with lemony sumac,smothered in soft onions, topped with crunchy pine nuts, and piled onto delicious flatbread',
  },
];

export default menuData;
